import Cookies from 'universal-cookie';

const isVeriiproDomain = () => {
    const host = process.env.REACT_APP_ALLOWED_HOST || '';
    return host.endsWith('.veriipro.com');
};

export const setCookie = (name, value, expiry = 1) => {
    const cookies = new Cookies();
    cookies.set(name, value, { path: '/' });
}

export const setCookieForCrossOrigin = (name, value) => {
    try {
        const cookies = new Cookies();
        cookies.set(name, value, {
            path: '/',
            ...(isVeriiproDomain() && { domain: '.veriipro.com' }),
            maxAge: 60 * 60 * 24 // 24 hours
        });
    } catch (error) {
        console.error('setCookieForCrossOrigin error:', error.message);
    }
};

export const getCookie = (name) => {
    const cookies = new Cookies();
    return cookies.get(name);
}

export const removeCookie = (name) => {
    const cookies = new Cookies();
    cookies.remove(name, { path: '/' });
}

export const removeCookieForCrossOrigin = (name) => {
    try {
        const cookies = new Cookies();
        cookies.remove(name, {
            path: '/',
            ...(isVeriiproDomain() && { domain: '.veriipro.com' })
        });
    } catch (error) {
        console.error('removeCookieForCrossOrigin error:', error.message);
    }
};

export const removeAllCookie = () => {
    const cookies = new Cookies();
    cookies.remove();
}